export default {
  companyDemoMetadata: {
    title: 'Демо доступ к психологическим тестам',
    demo: 'Демонстрация персонального теста',
    description:
      'На странице представлены ознакомительные версии тестов с примерами отчетов в нескольких представлениях.<br />Если вы заинтересовались одним из них, обратитесь к нашим менеджерам или в техническую поддержку.',
    note: 'Примечание: примеры отчетов не зависят от ответов в демонстрационном тесте, отчеты в конце опроса всегда одинаковые.',
    testExampleButton: 'Пример теста',
    testsTitle: {
      critical: 'Критическое мышление',
      burnout: 'Выгорание',
      frontStaff: 'FrontStaff',
      leadFive: 'Лидерская Пятёрка Компетенций (ЛПК)',
      personalFactor: '11 личностных факторов (11ЛФ)',
      bigFive: 'Большая Пятёрка Компетенций (БПК)',
      safetyStart: 'SafetyStart',
      leaderCase: 'LeaderCase',
      deMetrics: 'DeMetrics',
    },
    testsDescription: {
      critical: 'Экспресс-оценка способности к критическому анализу информации',
      burnout: 'Экспресс-оценка профессионального выгорания',
      frontStaff:
        'Экспресс-тест базовых компетенций и интеллектуального потенциала для тех, кто работает с людьми',
      leadFive:
        'Экспресс-оценка компетенций лидеров: менеджеров проектов, руководителей, предпринимателей, антикризисных менеджеров',
      personalFactor: 'Экспресс-тест потенциала к продажам',
      bigFive: 'Экспресс-оценка компетенций работников массовых специальностей',
      safetyStart:
        'Экспресс-тест для отбора и оценки сотрудников на предприятиях с повышенным уровнем опасности',
      leaderCase: 'Кейсовый экспресс-тест лидерского потенциала',
      deMetrics: 'Экспресс-оценка десяти значимых факторов мотивации и удовлетворённости в работе',
    },
  },
};
